import React from "react";
import Sidebar from "./Sidebar";
import IndexGist from "./gist/IndexGist";
import Navbar from "./Navbar";

const Home = () => {
  return (
    <div
      className="flex flex-row w-full min-h-screen overflow-hidden"
      style={{ backgroundColor: 'var(--color-ivory)' }}
    >
      <div
        className="w-full mt-14 flex justify-center overflow-auto pb-12"
        style={{ fontFamily: 'var(--font-primary)' }}
      >
        <IndexGist />
      </div>
    </div>
  );
};

export default Home;
